import React, { useState, useEffect } from 'react'
import { Paper, Stepper, Step, StepLabel, Typography, CircularProgress, Divider, Button, CssBaseline } from '@material-ui/core'
import { Link, useHistory } from 'react-router-dom'
import { commerce } from '../../../lib/commerce'
import useStyles from './style'
import AddressForm from '../AddressForm'
import PaymentForm from '../PaymentForm'
import illustrator from '../../../assets/order-completed.svg'

const steps = ['Alamat Pengiriman', 'Detail Pembayaran']

const Checkout = ({ cart, order, onCaptureCheckout, error, refreshCart }) => {
    const [activeStep, setActiveStep] = useState(0)
    const [shippingData, setShippingData] = useState({})
    const [checkoutToken, setCheckoutToken] = useState(null)
    const [isFinished, setIsFinished] = useState(false)
    const classes = useStyles()
    const history = useHistory()

    useEffect(() => {
            const generateToken = async () => {
              try {
                const token = await commerce.checkout.generateToken(cart.id, { type: 'cart' });
      
                setCheckoutToken(token);
              } catch {
                if (activeStep !== steps.length) history.push('/');
              }
            };
      
            generateToken();
        }, [cart]);

    const nextStep = () => setActiveStep((prevActiveStep) => prevActiveStep + 1)
    const backStep = () => setActiveStep((prevActiveStep) => prevActiveStep - 1)

    const next = (data) => {
        setShippingData(data)
        nextStep()
    }
    

    const timeout = () => {
        setTimeout(() => {
            setIsFinished(true)
        }, 3000)
    }

    let Confirmation = () => order.customer ? (
        <>
        <div>
            <Typography variant="h5">Terima Kasih Untuk Pembelian Anda, {order.customer.firstname} {order.customer.lastname}</Typography>
            <Divider className={classes.divider}/>
            <Typography variant="subtitle2">Order Reference: {order.customer_reference}</Typography>
            <img src={illustrator} alt="illustrator"/>
        </div>
        <br/>
        <Button component={Link} to="/" variant="outlined" type="button">Kembali</Button>
    </>
    ) : isFinished ? (
        <>
            <div>
                <Typography style={{textAlign: 'center', marginBottom: '20px'}} variant="h5">Terima Kasih Untuk Pembelian Anda</Typography>
                <img src={illustrator} alt="illustrator"/>
                <Divider className={classes.divider}/>
            </div>
            <br/>
            <Button component={Link} to="/" style={{margin: 'auto'}} variant="outlined" type="button">Kembali</Button>
        </>
    ) : (
        <div className={classes.spinner}>
            <CircularProgress/>
        </div>
    )

    if(error) {
        Confirmation = () => (
            <>
                <Typography variant="h5">Error: {error}</Typography>
                <br/>
                <Button component={Link} to="/">Kembali</Button>
            </>
        )
    }

    const Form = () => activeStep === 0 
    ? <AddressForm checkoutToken={checkoutToken} next={next}/>
    : <PaymentForm 
        shippingData={shippingData} 
        checkoutToken={checkoutToken} 
        backStep={backStep} 
        onCaptureCheckout={onCaptureCheckout} 
        nextStep={nextStep}
        timeout={timeout}
        refreshCart={refreshCart}
        />

    return (
        <>
         <CssBaseline>
            <div className={classes.toolbar} /> 
                <main className={classes.layout}>
                    <Paper className={classes.paper}>
                        <Typography variant="h4" align="center">Pembayaran</Typography>
                        <Stepper activeStep={activeStep} className={classes.stepper}>
                            {steps.map((step) => (
                                <Step key={step}>
                                    <StepLabel>{step}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>

                        {activeStep === steps.length ? <Confirmation/> : checkoutToken && <Form />}

                    </Paper>
            </main>  
         </CssBaseline>
        </>
    )
}

export default Checkout
